import React from 'react';
import { Link } from 'react-router-dom';
import { Home, LogOut } from 'lucide-react';
import { useAuth } from '../contexts/AuthContext';

function NavBar() {
  const { logout } = useAuth();

  const handleLogout = async () => {
    try {
      await logout();
    } catch (error) {
      console.error('Logout failed:', error);
    }
  };

  return (
    <nav
      className="fixed top-0 left-0 right-0 flex items-center justify-between px-4"
      style={{ height: '36px', backgroundColor: '#1E293B', zIndex: 10001 }}
    >
      <Link
        to="/"
        className="flex items-center gap-1.5 text-gray-200 text-sm font-medium hover:text-white transition-colors"
      >
        <Home className="w-3.5 h-3.5" />
        <span>Innovation Lab</span>
      </Link>
      <span
        className="select-none hidden sm:block"
        style={{ color: '#F59E0B', fontSize: '9px', fontWeight: 600, letterSpacing: '0.08em', textTransform: 'uppercase' }}
      >
        CONFIDENTIAL &mdash; PlumCloud Labs &mdash; Internal Use Only &mdash; Do Not Copy or Distribute
      </span>
      <button
        onClick={handleLogout}
        className="flex items-center gap-1.5 text-gray-200 text-xs hover:text-white transition-colors"
      >
        <LogOut className="w-3.5 h-3.5" />
        <span>Logout</span>
      </button>
    </nav>
  );
}

export default NavBar;
